/**
 * Remark-plugin: rutmarkörer (`[[ruta:v2]]`, se rutor.ts)
 * blir <ruta-box> (stycke som bara består av markörer) eller <ruta-link>
 * (markör mitt i en mening, ritas som en länk). Ett stycke med bara markörer
 * ersätts av block - ingen <div> inuti <p>.
 */
import {
	type Content,
	type Paragraph,
	type PhrasingContent,
	type Root,
	type Text,
} from 'mdast'
import { visit } from 'unist-util-visit'
import { RUTA_MARKER_RE, splitRutaSegments } from '#app/utils/rutor.ts'

const node = (id: string, inline: boolean) =>
	({
		type: inline ? 'text' : 'paragraph',
		value: '',
		children: [],
		data: {
			hName: inline ? 'ruta-link' : 'ruta-box',
			hProperties: { ruta: id },
		},
	}) as unknown as Content & PhrasingContent

export function remarkRutor() {
	return (tree: Root) => {
		visit(tree, 'paragraph', (p: Paragraph, index, parent) => {
			if (!parent || index == null) return
			const text = p.children
				.map(c =>
					c.type === 'text' ? c.value : c.type === 'break' ? '\n' : '\u0000',
				)
				.join('')
			if (text.includes('\u0000')) return
			const markers = [...text.matchAll(RUTA_MARKER_RE)]
			if (markers.length === 0) return
			if (text.replace(RUTA_MARKER_RE, '').trim() !== '') return
			const boxes = markers.map(m => node(m[1]!, false))
			parent.children.splice(index, 1, ...(boxes as Content[]))
			return index + boxes.length
		})
		visit(tree, 'text', (t: Text, index, parent) => {
			if (!parent || index == null) return
			// Samma tolkning som sajtens icke-remark-klienter (rutor.ts).
			const segments = splitRutaSegments(t.value)
			if (!segments.some(seg => seg.kind === 'ruta')) return
			const children: PhrasingContent[] = segments.map(seg =>
				seg.kind === 'text'
					? { type: 'text', value: seg.text }
					: node(seg.id, true),
			)
			;(parent.children as PhrasingContent[]).splice(index, 1, ...children)
			return index + children.length
		})
	}
}
